// extracted by mini-css-extract-plugin
export var card = "_r2-0";
export var content = "_r2-2";
export var details = "_r2-3";
export var icon = "_r2-1";
export var iconBlue = "_r2-5";
export var iconBrand = "_r2-4";
export var iconGrayBlue = "_r2-6";
export var iconGreen = "_r2-7";
export var iconIndigo = "_r2-8";
export var iconOrange = "_r2-9";
export var iconPurple = "_r2-a";
export var iconRed = "_r2-b";
export var iconWarning = "_r2-c";